import text from './text.json'

export default {
  translation: {
    text,
  },
}
